export const DEFAULT_CHAT_ROLE = 'general';

export const CHAT_ROLES = [
  { id: 'general', label: 'Normal chat' },
  { id: 'restaurant', label: 'Restaurant' },
  { id: 'shop', label: 'Shop' },
  { id: 'hotel', label: 'Hotel' },
  { id: 'gas-station', label: 'Gas station' },
  { id: 'airport', label: 'Airport' },
];
